<template>
    <div class="h-100">
        <ob1-cards
            :style="{ 'background-image': 'url(' + offer.banner + ')' }"
            :additional-classes="'shadow-none push-background bg-greige h-100'"
            :with-composite-link="false"
        >
            <div class="d-flex flex-column h-100 py-2 px-1 px-xl-2">
                <div class="flex-grow-1">
                    <p
                        class="py-0 mb-0 fw-bold"
                        v-html="offer.teaser"
                    />
                </div>
                <div v-if="offer.offerPageUrl">
                    <div class="d-flex justify-content-center">
                        <lien
                            :label="offer.name"
                            :href="offer.offerPageUrl"
                            :tms-category="'push_tuile'"
                            :is-link-arrow="true"
                            :open-new-tab="true"
                        />
                    </div>
                </div>
            </div>
        </ob1-cards>
    </div>
</template>

<script lang="ts">
import Lien from "../../../../common/components/ob1/Lien.vue";

export default {
    components: {
        Lien
    },
    props: {
        offer: {
            type: Object,
            required: true
        },
    },
}
</script>

<style lang="scss">
.push-background {
    background-size: cover;
    background-position : right;
    background-repeat : no-repeat;
}
</style>
